import { Alert, AlertDescription, AlertIcon, AlertTitle, Modal, ModalBody } from 'components/UI';

const AccessOverlay = () => (
  <Modal isOpen isCloseButton={false} closeOnEsc={false} isCentered size="xl" onClose={() => {}}>
    <ModalBody py={8}>
      <Alert
        sx={{
          flexDir: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          bgColor: 'transparent',
        }}
        status="error"
      >
        <AlertIcon mb={5} boxSize="40px" />
        <AlertTitle mb={5} color="black" fontSize="2xl" textTransform="uppercase">
          Not Authorized
        </AlertTitle>
        <AlertDescription textAlign="center">
          You do not have the required privileges to configure this product.
        </AlertDescription>
      </Alert>
    </ModalBody>
  </Modal>
);

export default AccessOverlay;
